var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 186,
    viewBox: "0 0 149 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.778 106.008H89.4463L82.9956 117.619L89.4463 129.23H102.778L109.229 117.619L102.778 106.008Z",
    fill: "url(#paint0_linear_834_4472)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1279 106.008H45.7964L39.3456 117.619L45.7964 129.23H59.1279L65.5786 117.619L59.1279 106.008Z",
    fill: "url(#paint1_linear_834_4472)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1954 93.7515H23.8639L17.4131 105.363L23.8639 116.974H37.1954L43.6461 105.363L37.1954 93.7515Z",
    fill: "url(#paint2_linear_834_4472)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8637 92.0305L37.1952 92.0305L43.6459 80.4192L37.1952 68.8079L23.8637 68.8079L17.413 80.4192L23.8637 92.0305Z",
    fill: "url(#paint3_linear_834_4472)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.734 92.0305L124.065 92.0305L130.516 80.4192L124.065 68.8079L110.734 68.8079L104.283 80.4192L110.734 92.0305Z",
    fill: "url(#paint4_linear_834_4472)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7963 79.1299L59.1278 79.1299L65.5785 67.5186L59.1278 55.9073L45.7963 55.9073L39.3456 67.5186L45.7963 79.1299Z",
    fill: "url(#paint5_linear_834_4472)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6616 79.1299L102.993 79.1299L109.444 67.5186L102.993 55.9073L89.6616 55.9073L83.2109 67.5186L89.6616 79.1299Z",
    fill: "url(#paint6_linear_834_4472)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7283 67.0891L81.0598 67.0891L87.5106 55.4778L81.0598 43.8665L67.7284 43.8665L61.2776 55.4778L67.7283 67.0891Z",
    fill: "url(#paint7_linear_834_4472)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.065 93.7515H110.733L104.283 105.363L110.733 116.974H124.065L130.516 105.363L124.065 93.7515Z",
    fill: "url(#paint8_linear_834_4472)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1732 118.694H67.1861L60.4181 130.305L67.1861 141.917H81.1732L87.9412 130.305L81.1732 118.694Z",
    fill: "url(#paint9_linear_834_4472)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2967 165.569H93.9257L91.8107 169.224L93.9257 172.88H98.2967L100.412 169.224L98.2967 165.569Z",
    fill: "url(#paint10_linear_834_4472)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4914 19.7834L54.8624 19.7834L56.9774 16.128L54.8624 12.4726L50.4914 12.4726L48.3764 16.128L50.4914 19.7834Z",
    fill: "url(#paint11_linear_834_4472)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.23 153.097H115.859L113.744 156.753L115.859 160.408H120.23L122.344 156.753L120.23 153.097Z",
    fill: "url(#paint12_linear_834_4472)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5586 32.2534L32.9296 32.2534L35.0446 28.598L32.9296 24.9426L28.5586 24.9426L26.4436 28.598L28.5586 32.2534Z",
    fill: "url(#paint13_linear_834_4472)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9299 153.097H28.5589L26.4439 156.753L28.5589 160.408H32.9299L35.0449 156.753L32.9299 153.097Z",
    fill: "url(#paint14_linear_834_4472)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.858 32.2534L120.229 32.2534L122.344 28.598L120.229 24.9426L115.858 24.9426L113.743 28.598L115.858 32.2534Z",
    fill: "url(#paint15_linear_834_4472)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8624 165.569H50.4914L48.3764 169.224L50.4914 172.88H54.8624L56.9774 169.224L54.8624 165.569Z",
    fill: "url(#paint16_linear_834_4472)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9263 19.7834L98.2973 19.7834L100.412 16.128L98.2973 12.4726L93.9263 12.4726L91.8113 16.128L93.9263 19.7834Z",
    fill: "url(#paint17_linear_834_4472)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.795 178.04H72.424L70.309 181.696L72.424 185.351H76.795L78.91 181.696L76.795 178.04Z",
    fill: "url(#paint18_linear_834_4472)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9938 7.31079L76.3648 7.31079L78.4798 3.65538L76.3648 -2.54573e-05L71.9938 -2.58394e-05L69.8788 3.65538L71.9938 7.31079Z",
    fill: "url(#paint19_linear_834_4472)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3117 147.938H69.477L64.7183 156.323L69.477 164.709H79.3117L84.0704 156.323L79.3117 147.938Z",
    fill: "url(#paint20_linear_834_4472)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4768 37.8452L79.3115 37.8452L84.0703 29.4593L79.3115 21.0733L69.4768 21.0733L64.7181 29.4593L69.4768 37.8452Z",
    fill: "url(#paint21_linear_834_4472)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M123.177 122.994H113.342L108.584 131.38L113.342 139.766H123.177L127.936 131.38L123.177 122.994Z",
    fill: "url(#paint22_linear_834_4472)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6107 136.757H48.7429L44.9359 143.423L48.7429 150.089H56.6107L60.4176 143.423L56.6107 136.757Z",
    fill: "url(#paint23_linear_834_4472)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2413 125.143H27.2477L23.8637 131.164L27.2477 137.185H34.2413L37.6252 131.164L34.2413 125.143Z",
    fill: "url(#paint24_linear_834_4472)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2106 60.6559L37.7074 54.5993L34.1853 48.6584L27.2792 48.5786L23.7825 54.6353L27.3045 60.5762L34.2106 60.6559Z",
    fill: "url(#paint25_linear_834_4472)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M143.262 110.954H135.831L132.236 117.405L135.831 123.856H143.262L146.857 117.405L143.262 110.954Z",
    fill: "url(#paint26_linear_834_4472)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9578 110.954H5.52718L1.9317 117.405L5.52718 123.856H12.9578L16.5533 117.405L12.9578 110.954Z",
    fill: "url(#paint27_linear_834_4472)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9707 73.9603L16.686 67.5252L12.8973 61.186L5.51305 61.0744L1.79771 67.5096L5.58646 73.8487L12.9707 73.9603Z",
    fill: "url(#paint28_linear_834_4472)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M132.314 67.526L136.029 73.9612L143.413 73.8496L147.202 67.5105L143.487 61.0753L136.103 61.1869L132.314 67.526Z",
    fill: "url(#paint29_linear_834_4472)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4048 85.5803H8.0999L4.08142 92.8911L8.0999 100.202H16.4048L20.4232 92.8911L16.4048 85.5803Z",
    fill: "url(#paint30_linear_834_4472)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M140.689 85.5803H132.384L128.366 92.8911L132.384 100.202H140.689L144.707 92.8911L140.689 85.5803Z",
    fill: "url(#paint31_linear_834_4472)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M100.046 136.757H92.1778L88.3708 143.423L92.1778 150.089H100.046L103.853 143.423L100.046 136.757Z",
    fill: "url(#paint32_linear_834_4472)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1779 48.5972L100.046 48.5972L103.853 41.9314L100.046 35.2657L92.1779 35.2657L88.3709 41.9314L92.1779 48.5972Z",
    fill: "url(#paint33_linear_834_4472)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7432 48.5972L56.611 48.5972L60.418 41.9314L56.611 35.2657L48.7432 35.2657L44.9362 41.9314L48.7432 48.5972Z",
    fill: "url(#paint34_linear_834_4472)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M113.342 62.3584L123.177 62.3584L127.936 53.9725L123.177 45.5865L113.342 45.5865L108.583 53.9725L113.342 62.3584Z",
    fill: "url(#paint35_linear_834_4472)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M108.583 93.7529H38.915L44.8866 104.289H59.7048L67.0033 116.545H81.158L88.2354 104.289H102.611L108.583 93.7529Z",
    fill: "url(#paint36_linear_834_4472)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3457 92.0317L108.583 92.0317L102.649 81.4956L87.922 81.4956L80.6685 69.2392L66.6012 69.2392L59.5675 81.4956L45.2804 81.4956L39.3457 92.0317Z",
    fill: "url(#paint37_linear_834_4472)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_834_4472",
    x1: 87.8883,
    y1: 103.788,
    x2: 110.849,
    y2: 124.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_834_4472",
    x1: 44.2383,
    y1: 103.788,
    x2: 67.1988,
    y2: 124.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_834_4472",
    x1: 22.3058,
    y1: 91.5317,
    x2: 45.2663,
    y2: 111.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_834_4472",
    x1: 38.7533,
    y1: 94.2503,
    x2: 15.7928,
    y2: 73.8901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_834_4472",
    x1: 125.623,
    y1: 94.2503,
    x2: 102.663,
    y2: 73.8901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_834_4472",
    x1: 60.6858,
    y1: 81.3497,
    x2: 37.7253,
    y2: 60.9894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_834_4472",
    x1: 104.551,
    y1: 81.3497,
    x2: 81.5906,
    y2: 60.9894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_834_4472",
    x1: 82.6179,
    y1: 69.3089,
    x2: 59.6574,
    y2: 48.9487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_834_4472",
    x1: 109.175,
    y1: 91.5317,
    x2: 132.136,
    y2: 111.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_834_4472",
    x1: 65.5514,
    y1: 116.474,
    x2: 88.6178,
    y2: 137.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_834_4472",
    x1: 93.4149,
    y1: 164.87,
    x2: 100.672,
    y2: 171.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_834_4472",
    x1: 55.3732,
    y1: 20.4823,
    x2: 48.1156,
    y2: 13.7797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_834_4472",
    x1: 115.348,
    y1: 152.398,
    x2: 122.605,
    y2: 159.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_834_4472",
    x1: 33.4404,
    y1: 32.9522,
    x2: 26.1828,
    y2: 26.2497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_834_4472",
    x1: 28.0481,
    y1: 152.398,
    x2: 35.3057,
    y2: 159.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_834_4472",
    x1: 120.74,
    y1: 32.9522,
    x2: 113.482,
    y2: 26.2497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_834_4472",
    x1: 49.9806,
    y1: 164.87,
    x2: 57.2381,
    y2: 171.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_834_4472",
    x1: 98.8081,
    y1: 20.4823,
    x2: 91.5505,
    y2: 13.7797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_834_4472",
    x1: 71.9132,
    y1: 177.341,
    x2: 79.1708,
    y2: 184.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_834_4472",
    x1: 76.8756,
    y1: 8.00962,
    x2: 69.6181,
    y2: 1.30708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_834_4472",
    x1: 68.3276,
    y1: 146.334,
    x2: 84.9486,
    y2: 161.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_834_4472",
    x1: 80.4609,
    y1: 39.4484,
    x2: 63.8399,
    y2: 24.3937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_834_4472",
    x1: 112.193,
    y1: 121.391,
    x2: 128.814,
    y2: 136.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_834_4472",
    x1: 47.8234,
    y1: 135.483,
    x2: 61.0431,
    y2: 147.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_834_4472",
    x1: 26.4303,
    y1: 123.992,
    x2: 38.3516,
    y2: 134.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_834_4472",
    x1: 39.1128,
    y1: 54.467,
    x2: 23.8901,
    y2: 59.4436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_834_4472",
    x1: 134.963,
    y1: 109.721,
    x2: 147.723,
    y2: 121.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_834_4472",
    x1: 4.65875,
    y1: 109.721,
    x2: 17.4195,
    y2: 121.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_834_4472",
    x1: 18.1882,
    y1: 67.3897,
    x2: 1.97612,
    y2: 72.7645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_834_4472",
    x1: 135.395,
    y1: 75.3299,
    x2: 138.847,
    y2: 58.6024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_834_4472",
    x1: 7.1293,
    y1: 84.1827,
    x2: 21.5667,
    y2: 96.8492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_834_4472",
    x1: 131.413,
    y1: 84.1827,
    x2: 145.851,
    y2: 96.8492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_834_4472",
    x1: 91.2583,
    y1: 135.483,
    x2: 104.478,
    y2: 147.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_834_4472",
    x1: 100.965,
    y1: 49.8715,
    x2: 87.7454,
    y2: 37.8204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_834_4472",
    x1: 57.5305,
    y1: 49.8715,
    x2: 44.3108,
    y2: 37.8204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_834_4472",
    x1: 124.326,
    y1: 63.9616,
    x2: 107.705,
    y2: 48.9069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_834_4472",
    x1: 51.9086,
    y1: 91.5742,
    x2: 68.0285,
    y2: 130.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_834_4472",
    x1: 95.67,
    y1: 94.2104,
    x2: 79.4799,
    y2: 55.6034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7722FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC11BB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.55ab577bb383c47f57f258d39e7cfc82.svg";
export { ForwardRef as ReactComponent };